type ColorSchemeKeys = 'interactive' | 'base' | 'accent' | 'foreground'

// ColorScheme is a partial record, but values are always strings (never undefined)
type ColorScheme = Partial<
  Record<`--${ColorSchemeKeys}` | `--${ColorSchemeKeys}-${string}`, string>
>

type ColorSchemeConfig = { colorName: string; color0?: string }

const generateColors = ({
  prefix,
  colorName,
  color0 = ''
}: {
  prefix: ColorSchemeKeys
  colorName: string
  color0?: string
}): ColorScheme => {
  const colors: Record<string, string> = {}
  let i = 1
  if (color0) {
    colors[`--${prefix}-${i}`] = `var(--color-${color0})`
    i++
  }
  let k = 1
  for (i; i <= 11; i++) {
    colors[`--${prefix}-${i}`] = `var(--color-${colorName}-${k * 100})`
    k++
  }
  return colors as ColorScheme
}

export const colorSchemes: Record<string, ColorScheme> = {} as Record<
  string,
  ColorScheme
>

colorSchemes['interactive-loContrast'] = {
  '--interactive-foreground': 'var(--foreground)',
  '--interactive-1': 'var(--accent-1)',
  '--interactive-2': 'var(--accent-2)',
  '--interactive-3': 'var(--accent-3)'
}

colorSchemes['interactive-hiContrast'] = {
  '--interactive-foreground': 'var(--foreground-7-plus)',
  '--interactive-1': 'var(--accent-9)',
  '--interactive-2': 'var(--accent-10)',
  '--interactive-3': 'var(--accent-11)'
}

const colorNames = [
  'primary',
  'grey',
  'blue',
  'pink',
  'purple',
  'cyan',
  'green',
  'magenta',
  'red',
  'teal',
  'orange',
  'yellow',
  'lime'
]

const createVariants = () =>
  Object.fromEntries(
    colorNames.flatMap((c) => [
      [`${c}1`, { colorName: c, color0: 'white' }],
      [`${c}2`, { colorName: c }]
    ])
  ) as Record<string, ColorSchemeConfig>

export const bases = createVariants()
export const accents = bases
;(() => {
  Object.entries(bases).forEach(
    ([name, config]: [string, ColorSchemeConfig]) => {
      const themeName = `base-${name}`
      colorSchemes[themeName] = {
        '--foreground': 'var(--color-grey-1000)',
        '--foreground-7-plus': 'var(--color-white)',
        ...generateColors({
          prefix: 'base',
          colorName: config.colorName,
          color0: config.color0
        })
      }
    }
  )

  Object.entries(accents).forEach(
    ([name, config]: [string, ColorSchemeConfig]) => {
      colorSchemes[`accent-${name}`] = generateColors({
        prefix: 'accent',
        colorName: config.colorName,
        color0: config.color0
      })
    }
  )
})()
